// extracted by mini-css-extract-plugin
module.exports = {"horizontalList":"HorizontalList_horizontalList__mG4_6"};